/**
 * AutoImporting components
 * @param path
 * @returns {function(): *}
 */
const page = path => () => import(/* webpackChunkName: '' */ `./components/${path}`).then(m => m.default || m)

export const routes = [
    {
        path: '/placements',
        name: 'Placements',
        component: page('PlacementList'),
    },
    {
        path: '/placements/:id',
        name: 'Show Placement',
        component: page('PlacementView'),
        hidden: true
    }
]
